import { useContext } from 'react';
import ModalContext from './ModalContext.js';

/**
 * Hook per la gestione del contesto di una modale. @see ModalContext.
 */
function useModalContext() {
    return useContext(ModalContext);
}

export { useModalContext as default };
